import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';
import { ApiServiceService } from './_service/api-service.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate {
  userdetails: any[] = [];
  
  constructor(private router: Router, private dataService: ApiServiceService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const user = localStorage.getItem('login_user_details');
    const token = window.sessionStorage.getItem('validUserToken');
    if (user && token === 'true') {
      this.userdetails.push(JSON.parse(user));
      const userDetails = JSON.parse(user);
      if (this.isAuthPage(state.url)) {
        this.redirectToDashboard(userDetails);
        return false;
      }
      if (!state.url.includes(userDetails.type)) {
        this.redirectToDashboard(userDetails);
        return false;
      }
      return true; // Allow access to non-auth pages
    } else {
      return this.handleUnauthenticatedAccess(state.url);
    }
  }


  private isAuthPage(url: string): boolean {
    console.log(url);
    return url === '/login' || url === '/self-registration' || url === '/forgot_password';
  }

  private redirectToDashboard(userDetails: any): void {
    const redirect = this.dataService.redirectUrl || this.getDefaultRedirectUrl(userDetails);

    if (userDetails.type=='superadmin') {
      this.router.navigate([redirect]);
    } else if (userDetails.type=='student') {
      this.router.navigate([redirect + '/stdashboard']);
    } else if (userDetails.type=='mentors') {
      this.router.navigate([redirect + '/mtdashboard']);
    } else {
      this.showAccountClosedAlert();
    }
  }



  
  private getDefaultRedirectUrl(userDetails: any): string {
    switch (userDetails.category) {
      case 'SAD': return 'superadmin';
      case 'DA': return 'districtadmin';
      default: return 'student';
    }
  }

  private handleUnauthenticatedAccess(url: string): boolean | UrlTree {
    if (this.isAuthPage(url)) {
      return true; // Allow access to auth pages
    }
    this.router.navigate(['/login'], { replaceUrl: true });
    return false; // Redirect to login if not authenticated
  }
  private showAccountClosedAlert(): void {
    // Swal.fire({
    //   title: "Your account has already been closed",
    //   icon: "info",
    //   confirmButtonText: "OK",
    //   iconColor: "#015792",
    //   customClass: {
    //   container: 'custom-modal-container',
    //   }
    // }).then(() => {
      localStorage.removeItem('user_district');
      localStorage.removeItem('user_constituency');
      localStorage.removeItem('login_user_details');
      sessionStorage.removeItem('validUserToken');
      sessionStorage.clear();
      this.router.navigate(['/login'], { replaceUrl: true });
      //window.location.reload();
    // });
  }
}


